export { EloPaypalNVPIcon } from './paypal-nvp-icon'
